// 문서용 응답 예시를 탭으로 보여주는 컴포넌트 (읽기 전용)
import { useEffect, useState } from 'react';
import JsonCode from './JsonCode';
import classes from './DescriptionPageTemplate.module.css';

/**
 * 응답 예시.
 *
 * API TEST 영역의 에디터와 달리 편집할 수 없다. 그쪽은 Send 를 누르면 실제 응답으로
 * 덮어써지고 사용자가 값을 고칠 수도 있어, 문서에 적힌 정본이 화면에서 사라진다.
 * 이 컴포넌트는 항상 그 API 의 정답을 보여주는 자리다.
 */
const ResponseExamples = ({ success, error, callback }) => {
  // 값이 있는 탭만 노출한다. 버전마다 제공하는 예시가 다르다
  const tabs = [
    { key: 'success', label: 'Success', status: '200', value: success },
    { key: 'error', label: 'Error', status: 'error', value: error },
    { key: 'callback', label: 'Api Callback', status: 'POST', value: callback },
  ].filter((tab) => tab.value);

  const [activeKey, setActiveKey] = useState(tabs[0]?.key);
  const [copied, setCopied] = useState(false);

  // 버전을 바꾸면 없는 탭이 선택된 채로 남을 수 있다
  useEffect(() => {
    setActiveKey(tabs[0]?.key);
  }, [success, error, callback]); // eslint-disable-line react-hooks/exhaustive-deps

  if (tabs.length === 0) return null;

  const active = tabs.find((tab) => tab.key === activeKey) || tabs[0];

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(active.value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      window.prompt('아래 내용을 복사하세요', active.value);
    }
  }

  return (
    <div className={classes.codeBlock}>
      <div className={classes.codeBar}>
        <div className={classes.codeTabs}>
          {tabs.map((tab) => (
            <button
              type="button"
              key={tab.key}
              className={
                tab.key === active.key
                  ? `${classes.codeTab} ${classes.codeTabActive}`
                  : classes.codeTab
              }
              onClick={() => setActiveKey(tab.key)}
            >
              {tab.label}
              <span className={classes[`codeStatus_${tab.key}`]}>{tab.status}</span>
            </button>
          ))}
        </div>
        <button type="button" className={classes.codeCopy} onClick={handleCopy}>
          {copied ? '복사됨' : '복사'}
        </button>
      </div>
      <JsonCode value={active.value} className={classes.codeBody} />
    </div>
  );
};

export default ResponseExamples;
